import moment from 'moment';
import {css} from 'glamor';
import {SearchInput} from '../../components/SearchInput';
import {SelectInput} from '../../components/SelectInput';
import {DateInput} from '../../components/DateInput';
import {Button} from '../../components/Button';
import {SUPPORT_TYPE_SEARCH_OPTIONS, SUPPORT_STATUS_SEARCH_OPTIONS} from '../../lib/enums';

const filterRowTwoColStyle = css({
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridColumnGap: 16,
    '@media (max-width: 768px)': {
        gridTemplateColumns: '1fr',
    },
});

export default function SearchFilterPanel({filters, onFilterChange}) {
    return (
        <div>
            <SearchInput
                placeholder="Search by title, type..."
                aria-label="Search support tickets"
                value={filters.searchTerm}
                onChange={(e) => onFilterChange({...filters, searchTerm: e.target.value})}
            />

            <div className={filterRowTwoColStyle}>
                <SelectInput
                    placeholder="All Types"
                    aria-label="Filter by support type"
                    options={SUPPORT_TYPE_SEARCH_OPTIONS}
                    value={filters.supportType}
                    onChange={(e) => onFilterChange({...filters, supportType: e.target.value})}
                />
                <SelectInput
                    placeholder="All Statuses"
                    aria-label="Filter by status"
                    options={SUPPORT_STATUS_SEARCH_OPTIONS}
                    value={filters.status}
                    onChange={(e) => onFilterChange({...filters, status: e.target.value})}
                />
            </div>

            <div className={css({
                display: 'grid',
                gridTemplateColumns: (filters.dateFrom || filters.dateTo) ? '1fr 1fr auto' : '1fr 1fr',
                gridColumnGap: 16,
                alignItems: 'start',
                '@media (max-width: 768px)': {
                    gridTemplateColumns: '1fr',
                },
            })}>
                <DateInput
                    label="From Date"
                    floatPicker
                    placeholder="From"
                    isOutsideRange={filters.dateTo
                        ? (day) => day.isAfter(moment(filters.dateTo), 'day')
                        : () => false}
                    value={filters.dateFrom}
                    onChange={(val) => onFilterChange({...filters, dateFrom: val})}
                />
                <DateInput
                    label="To Date"
                    floatPicker
                    placeholder="To"
                    isOutsideRange={filters.dateFrom
                        ? (day) => day.isBefore(moment(filters.dateFrom), 'day')
                        : () => false}
                    value={filters.dateTo}
                    onChange={(val) => onFilterChange({...filters, dateTo: val})}
                />
                {(filters.dateFrom || filters.dateTo) && (
                    <Button
                        flavour="dark"
                        spaceBelow="none"
                        onClick={() => onFilterChange({...filters, dateFrom: '', dateTo: ''})}
                        aria-label="Clear dates"
                        style={{marginTop: 28}}
                    >Clear</Button>
                )}
            </div>
        </div>
    );
}
